import { Box, Button } from '@mui/material';
import { NavigateNext, NavigateBefore } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import '../../theme/newPost.css';

interface StepNavigationProps {
  activeStep: number;
  totalSteps: number;
  onNext: () => void;
  onBack: () => void;
  isNextDisabled?: boolean;
}

const StepNavigation: React.FC<StepNavigationProps> = ({
  activeStep,
  totalSteps,
  onNext,
  onBack,
  isNextDisabled = false
}) => {
  const { t } = useTranslation();
  const isFirstStep = activeStep === 0;
  const isLastStep = activeStep === totalSteps - 1;

  return (
    <Box className="new-post-navigation">
      <Button
        variant="outlined"
        onClick={onBack}
        disabled={isFirstStep}
        startIcon={<NavigateBefore />}
        className="new-post-navigation-button"
      >
        {t('new_post.back')}
      </Button>
      
      {!isLastStep && (
        <Button
          variant="contained"
          onClick={onNext}
          disabled={isNextDisabled}
          endIcon={<NavigateNext />}
          className="new-post-navigation-button"
        >
          {t('new_post.next')}
        </Button>
      )}
    </Box>
  );
};

export default StepNavigation;
